<template>
    <section id="contacts" class="contacts" :class="{loading:loading}">
        <h2>{{$t('contacts.title')}}</h2>
       
        <div class="contacts-error" v-if="error">{{$t('contacts.error')}}
            <a class="link" @click="state = 'form'">{{$t('contacts.try')}}</a>
        </div>

        <div class="container" >
            <form class="form" @submit.prevent="submit" v-show="state == 'form'">
                <div class="row layout-wrap">
                    <div class="col">
                        <div class="field">
                            <input class="control" type="text" name="name" :placeholder="$t('contacts.name')" required v-model="name" />
                        </div>
                        <div class="field">
                            <input class="control" type="text" name="phone" :placeholder="$t('contacts.phone')" v-model="phone" />
                        </div>
                        <div class="field">
                            <input class="control" type="email" name="email" :placeholder="$t('contacts.email')" required v-model="email" />
                        </div>
                    </div>
                    <div class="col">
                        <div class="field">
                            <textarea class="control" name="message" :placeholder="$t('contacts.message')" v-model="message" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col center"><button class="button" type="submit" :disabled="!isValid">{{$t('contacts.send')}}</button></div>
                </div>
            </form>
            <div class="center" v-show="state == 'checkbox'"> 
                <div class="helptext">{{$t('contacts.not a robot')}}</div>
                <div id="contactsForm" class="not-robot"></div>
            </div>
        </div>

        <div class="contacts-success" v-if="sent">{{$t('contacts.message sent')}}</div>

    </section>
</template>

<script>
import formsService from '../services/forms.service';
import ga from '../plugins/ganalitycs'

    export default {
        name: 'Contacts',
        data() {
            return {
                message: null,
                email: null,
                phone: null,
                name: null,
                loading: false,                
                state: 'form',
                error: null,
                sent: false,
                recaptchaId: null
            }
        },
        mounted(){
        },
        
        computed:{
            isValid(){
                return this.name && this.email;
            }
        },

        methods:{
            
            async submit(event){
                const formData = new FormData(event.target);
                try{
                    const token = await grecaptcha.execute('6LfOmLgUAAAAAKBESrjmcSntVW5_UZo9c_wWiMI6', {action: 'homepage'});                
                    formData.set("g-recaptcha-response-v3", token);
                }
                catch(e){
                    console.error("Failed to set recapture token");
                }
                
                if (this.recaptchaId) grecaptcha.reset(this.recaptchaId);
                await this.sendMessage(formData);
            },

            async sendMessage(formData){
                try{
                    this.state = 'form'; 
                    this.sent = false;  
                    this.error = null;
                    this.loading = true;
                    var result = await formsService.post(formData); 
                    ga.sendForm('sendformmbk777', 'request');
                    this.loading = false;
                    this.sent = true;                   
                }catch(err){
                    console.error(err, "failed to send request");
                    const errorCode = err.response.data.error;
                    this.loading = false;
                    if (errorCode == 'recaptcha failed'){
                        this.state = 'checkbox'; 
                        if(!this.recaptchaId)  
                            this.recaptchaId = grecaptcha.render('contactsForm', {
                                'sitekey' : '6LdjmrgUAAAAAHgFcGYFY_j7jOzt0vD4_WXATdO7',
                                'theme' : 'light',
                                'callback' : async (token) => {
                                    formData.delete('g-recaptcha-response-v3');
                                    formData.set("g-recaptcha-response", token);
                                    await this.sendMessage(formData);
                                },
                            });
                    }
                    else{
                        this.error = 'error';  
                    }                        
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .webp {
        .contacts{
            background-image: url('/assets/yellow_bg.jpg.webp');
        }
    }

    .contacts {
        background: url('/assets/yellow_bg.jpg');
        background-size: cover;
        padding-top: 4*$spacer;
        padding-bottom: 4*$spacer;
        color: $black;
    }

    .contacts-error,
    .contacts-success {
        font-size: 2rem;
        text-align: center;
        padding: $spacer*2 $spacer;
    }

    .contacts-error {
        background: rgba($red, 0.7);

        .link {
           color: $white;
           text-decoration: underline;
           cursor: pointer;

           &:hover {
            color: darken($white, 10);
           }
        }
    }

    .contacts-success {
        position: relative;
        margin-bottom: -4*$spacer;
        background: rgba($green, 0.8);
    }

    h2 {
        font-size: 6rem;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        margin: 0;
        padding: 4*$spacer $spacer;
    }

    h3 {
        font-size: 3rem;
        font-weight: normal;
        text-align: center;
        margin: 0;
        padding: 0 $spacer 4*$spacer $spacer;
    }

    .helptext {
        font-size: 2rem;
        margin-bottom: $spacer;
        text-align: center;
    }

    .not-robot {
        display: inline-block;
        margin-bottom: 4*$spacer;
        text-align: center;
    }

    .form {
        .field {
            flex: 1 1 auto;
            justify-content: flex-start;
            align-items: stretch;
            width: 50%;
            padding: $spacer;
        }

        .control {
            display: block;
            width: 100%;
            line-height: 48px;
            border: 0;
            padding: 0 $spacer;
            font-size: 1.4rem;
            background: $white;
            color: $black;
        }

        textarea {
            height: 100%;
        }

        .button {
            margin: $spacer auto;
        }
    }

    .layout-wrap .col {
        display: flex;
        flex-wrap: wrap;
        width: 50%;
        flex: 0 0 auto;
        padding: 0;

        & + .col {
            align-self: stretch;
        }
    }


    @media (max-width: ($mobile)-1) and (orientation: portrait) {
        .form {
            .row  {
                display: block;
            }

            .col, .field {
                display: block;
                width: 100%;
            }
        }
    }
</style>
